export const getUserMenuList = (state) => state.user.menu;

export const getMenuStatus = (state) => state.user.menuStatus || "idle";

export const getIsMenuLoading = (state) =>
  state.user.menuStatus === "loading" || state.user.menuStatus === "idle";
